module.exports = __webpack_public_path__ + "img/sobre.98ca1cd2.svg";